import { HttpErrorResponse } from '@angular/common/http';

export class ErrorsUtils {
  static MISSING_ARTICLE = 'MissingMandatoryRecommendation';
  static MISSING_METADATA = 'MissingMetadataError';
  static ITEMFEED_NOT_FOUND = 'ItemFeedNotFoundError';
  static ITEMFEED_ALREADY_EXISTS = 'ItemFeedAlreadyExists';
}

export interface MediegoError {
  errorId: string;
  message: string;
  details?: unknown;
}

export class PlanificationForbiddenError extends Error {
  constructor(public readonly cause: HttpErrorResponse) {
    super('PLANIFICATION_FORBIDDEN');
    this.name = 'PlanificationForbiddenError';
  }
}
